import React, {  Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary"; // Make sure to create this component
import Loader from "../components/Loader";  
import EditxEVMPD from "../pages/idmp/EditxEVMPD";
import IdmpAdd from "../pages/idmp/IdmpAdd";
import AssociateProcess from "../pages/P&T/AssociateProcess";
import InitiateProcessPage from "../pages/P&T/InitiateProcess";
import ViewProcess from "../pages/P&T/ViewProcess";
import GlobalSearchList from "../components/GlobalSearchList";

const IdmpxEVMPDList = React.lazy(() => import("../pages/idmp/Idmp-xEVMPDList"));
const EditxEVMPDPage = React.lazy(() => import("../pages/idmp/EditxEVMPD"));


const routesForm = [
  {
    path: "*",
    element: (
      <Navigate to="/xevmpd" />
    ),
  },
  {
    path: "/xevmpd",
    element: (
        <Suspense fallback={<Loader />}>
          <IdmpxEVMPDList />
        </Suspense>
     
    ),
  },
  {
    path: "/edit-xevmpd",
    element: (
        <Suspense fallback={<Loader />}>
          <EditxEVMPDPage />
        </Suspense>
    ),
  },
  {
    path: "/add-xevmpd",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <IdmpAdd />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/view-xevmpd",
    element: (
     
        <Suspense fallback={<Loader />}>
          <EditxEVMPDPage />
        </Suspense>
      
    ),
  },
  {
    path: "/associateProcess",
    element: (<Suspense fallback={<Loader />}><AssociateProcess /></Suspense>),
  },
  {
    path: "/initiateProcess",
    element: (<Suspense fallback={<Loader />}><InitiateProcessPage /></Suspense>),
  },
   {
    path: "/viewProcess",
    element: <ViewProcess  />,
    children: [
      {
        path: "",
        element: <ViewProcess />,
      },
      {
        path: ":id",
        element: <ViewProcess />,
      },
    ],
  },
   {
    path:"xevmpd/edit-xevmpd/:recordId",
   element: (
    <Suspense fallback={<Loader />}>
      <EditxEVMPD />
    </Suspense>
  )
},
{
    path:"xevmpd/view-xevmpd/:recordId",
   element: (
    <Suspense fallback={<Loader />}>
      <EditxEVMPD />
    </Suspense>
  )
},
{
    path: "/XevmpdSearchResult",
    //element: <Layouts />,
    children: [
      {
        path: "/XevmpdSearchResult",
        element: <GlobalSearchList />,
      },
    ],
  },

];

const Router = createBrowserRouter(routesForm);

export { Router };







